import { render, staticRenderFns } from "./SmsReport.vue?vue&type=template&id=19716040&scoped=true"
import script from "./SmsReport.vue?vue&type=script&lang=js"
export * from "./SmsReport.vue?vue&type=script&lang=js"
import style0 from "./SmsReport.vue?vue&type=style&index=0&id=19716040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19716040",
  null
  
)

export default component.exports